// @react/hooks/useCalendarCalendar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { calendarCalendarStore } from '@core/stores';

/**
 * React hook for Calendar operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useCalendarCalendar } from '@react/hooks';
 *
 * const CalendarList = observer(() => {
 *   const store = useCalendarCalendar();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useCalendarCalendar() {
  return calendarCalendarStore;
}
